import React from 'react';
import AsyncSelect from 'react-select/async';
import Select, { components } from 'react-select';
import { Card, Image, Row } from 'react-bootstrap';
import style from './style.module.less';
import CrossIcon from '../../../img/cross.svg';
import FindIcon from '../../../img/finder.svg';

function FindWithSelectComponent({
  noOptionsMessage,
  loadingMessage,
  placeholder,
  value,
  defaultOptions,
  defaultValue,
  loadOptions,
  onInputChange,
  onChange,
  clearInputState,
  marginRowZero,
}) {
  // eslint-disable-next-line react/no-unstable-nested-components
  function DropdownIndicator(props) {
    return (
      <components.DropdownIndicator {...props}>
        <></>
      </components.DropdownIndicator>
    );
  }

  function IndicatorSeparator({
    innerProps,
  }) {
    return <span className={style.indicatorSeparator} {...innerProps} />;
  }

  function ClearIndicator(props) {
    const {
      children,
      getStyles,

      innerProps: { ref, ...restInnerProps },
    } = props;
    return (
      <div
        {...restInnerProps}
                // onMouseDown={(e)=>{
                //     // e.preventDefault()
                //     // e.stopPropagation()
                // }}
        onClick={() => {
          clearInputState();
          // clearInputState()
        }}
        ref={ref}
        style={getStyles('clearIndicator', props)}
      >
        <div style={{ padding: '0px 5px' }}><img src={CrossIcon} width={15} height={15} /></div>
      </div>
    );
  }

  return (
    <Row className={marginRowZero ? 'm-0' : ''}>
      <Card>
        <Card.Body>
          <AsyncSelect
            className={style.asyncSelect}
            isClearable
            classNamePrefix="react-select"
            styles={{
              control: (base) => ({
                ...base,
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
                padding: 5,
              }),
            }}
            components={{
              DropdownIndicator, IndicatorSeparator, ClearIndicator, Control,
            }}
                // styles={{control: (styles) => ({ ...styles, backgroundColor: 'black' })}}
            noOptionsMessage={noOptionsMessage}
            loadingMessage={loadingMessage}
            placeholder={placeholder}
            value={value ?? ' 1'}
            defaultOptions={defaultOptions}
            defaultValue={defaultValue}
            loadOptions={loadOptions}
            onInputChange={onInputChange}
            onChange={onChange}
          />
        </Card.Body>
      </Card>
    </Row>
  );
}

export default FindWithSelectComponent;

function Control({ children, ...props }) {
  return (
    <components.Control {...props}>
      <img src={FindIcon} width={35} height={35} />
      {' '}
      {children}
    </components.Control>
  );
}
